export default {"src":"/_next/static/media/instagram-icon.1b9553ad.svg","height":25,"width":25};